module.exports = __webpack_public_path__ + "static/media/033-saint-kitts-and-nevis.c59f94fb.svg";